export default "__VITE_ASSET__Bl31bO23__"